<kno2-table
    [columns]="columns()"
    [data]="events().items"
    (onFilter)="filterEvents($event)">
    <ng-template
        #status
        let-event>
        <kno2-signatures-status-cell-content [event]="event" />
    </ng-template>
    <ng-template
        #subject
        let-event>
        <span
            data-bs-toggle="tooltip"
            [title]="event.subject">
            {{ event.subject }}
        </span>
    </ng-template>
    <ng-template
        #toAddress
        let-event>
        <span
            data-bs-toggle="tooltip"
            [title]="event.to">
            {{ event.to || "N/A" }}
        </span>
    </ng-template>
    <ng-template
        #fromAddress
        let-event>
        <span
            data-bs-toggle="tooltip"
            [title]="event.from">
            {{ event.from || "N/A" }}
        </span>
    </ng-template>
</kno2-table>

<kno2-pagination
    [collectionSize]="events().totalCount"
    [page]="pageOptions().pageStart"
    [showPageInput]="true"
    [pageSize]="pageOptions()?.pageSize"
    (pageChange)="updateEventsQuery({ pageStart: $event })" />
